import jQuery from 'jquery';

function loggedInActions($, response){
	// user is logged in.
	let loginWidgets = document.querySelectorAll('[data-sf-role="sf-logged-in-view"]');
	if(loginWidgets != null) {

		loginWidgets.forEach((elem) => {
			elem.style.display = "flex";
		})
	}

	let userName = document.querySelector('[data-sf-role="sf-logged-in-name"]');

	if(userName)
	{
		userName.innerHTML = response.DisplayName;
	}
}

/**
 * Logged in modifications.
 *
 * @export
 */
export default function() {
	const $ = jQuery; 

	$.ajax({
		url: '/rest-api/login-status'
	}).then(response => {
		
		if(!response.IsLoggedIn) return;

		loggedInActions($, response);

	});



}


// WEBPACK FOOTER //
// ./assets/src/js/components/logged-in.js